import { ResponseMessageType } from './ResponseMessageType';

export class ResponseMessage {
  type: ResponseMessageType;
  value: string;
}



// WEBPACK FOOTER //
// ./src/app/core/services/ResponseMessage.ts